/*
DO NOT MANUALLY TRANSLATE!
Follow the instructions in the README.md to conveniently update translations.
*/

export default {
  "CookieMessage.old.link": "Ulteriori informazioni",
  "CookieMessage.old.text":
    "Per ottimizzare il funzionamento del nostro webshop,  utilizziamo cookie. Visualizza la nostra politica sui cookie.",
  "CookieMessage.link": "Accettazione cookies",
  "CookieMessage.more_information": "Maggiori informazioni sui cookie Kramp",
  "CookieMessage.return": "Indietro",
  "CookieMessage.intro.body":
    "Questi cookie vengono generati sia da Kramp che da terze parti. Inutile dire che la Sua privacy è importantissima per noi. Se si fa clic su Accetta i cookie, si acconsente all'uso di tali cookie. Accettarli consente al nostro sito web di funzionare correttamente. Esempi di come vengono utilizzati:",
  "CookieMessage.intro.list.1": "Accesso automatico (Login) a Il mio account",
  "CookieMessage.intro.list.2":
    "Analisi del comportamento dei visitatori per migliorare il sito web",
  "CookieMessage.intro.list.3":
    "Creazione di profili dei clienti per proporre loro informazioni e annunci personalizzati",
  "CookieMessage.intro.extra":
    'Se non si desidera accettare i cookie, è possibile cambiare le <a>impostazioni</a>. Per ulteriori informazioni, leggere la nostra <a href="{legalLink}">dichiarazione sulla privacy e sui cookie</a>.',
  "CookieMessage.intro.title": "Kramp verwendet Cookies",
  "CookieMessage.settings.body":
    "È possibile scegliere fra tre impostazioni dei cookie. Se si sceglie l'impostazione Standard sarà possibile utilizzare al meglio tutte le funzioni del sito web.",
  "CookieMessage.settings.standard.title": "Standard (più comune):",
  "CookieMessage.settings.standard.body":
    "i cookie vengono utilizzati per l'accesso, gli ordini, le analisi, le informazioni personalizzate, i social media e per i cookie di terze parti.",
  "CookieMessage.settings.restricted.title": "Limitata:",
  "CookieMessage.settings.restricted.body":
    "i cookie vengono utilizzati per l'accesso, gli ordini, le analisi e le informazioni personalizzate.",
  "CookieMessage.settings.highly_restricted.title": "Molto limitata:",
  "CookieMessage.settings.highly_restricted.body":
    "viene utilizzata la quantità minima di cookie. Solo per l'accesso, gli ordini e per permettere al sito web di funzionare in modo corretto.",
  "CookieMessage.settings.options.title": "Questa impostazione permette di:",
  "CookieMessage.settings.option.1":
    "Utilizzare i cookie per far sì che il sito web funzioni correttamente",
  "CookieMessage.settings.option.2": "Analizzare il comportamento degli utenti",
  "CookieMessage.settings.option.3": "Ottenere statistiche personali",
  "CookieMessage.settings.option.4":
    "Visualizzare le informazioni che potrebbero essere di interesse",
  "CookieMessage.settings.option.5":
    "Utilizzare le informazioni per i nostri annunci",
  "CookieMessage.settings.option.6": "Ottenere statistiche anonime",
  "CookieMessage.settings.option.7": "Condividere le informazioni personali",
  "CookieMessage.settings.title": "Impostazioni dei cookie",
  "CookiePage.url": "politica-sulla-privacy-cookies",
};
